export default new function () {
    let self = this;

    self.add = function(data) {
        wv.sendTextMessage(text_addAnnotation + text_seperator + data.info.authorId + ":" + data.id + ":" + data.info.text + ":default:" +
            serializeV3(data.location.normal) + ":" + serializeV3(data.location.position) + ":" + data.location.modelId + ":" + data.location.branchId + ":" + data.info.authorName);
    };

    self.remove = function (authorId, annotationId) {
        wv.sendTextMessage(text_removeAnnotation + text_seperator + authorId + ":" + annotationId);
    };

    self.deleteByAuthor = function (authorId) {
        wv.sendTextMessage(text_removeAllAnnotationOfAUser + text_seperator + authorId);
    };

    self.deleteAll = function (excludeHelperObjects = false) {
        wv.sendTextMessage(text_removeAllAnnotationOfAllUser + text_seperator + (excludeHelperObjects ? "1" : "0"));
    };

    self.changeText = function (authorId, annotationId, newText) {
        wv.sendTextMessage(text_changeAnnotationText + text_seperator + authorId + ":" + annotationId + ":" + newText);
    };

    self.setVisibility = function (isVisible) {
        wv.sendTextMessage(text_setAllAnnotationsVisibility + text_seperator + (isVisible ? "1" : "0"));
    };
};
